<div class="mrs-table-container">
  <div class="mrs-table-inner-container">
    <div class="table-heading">
      Team Members
    </div>

    <div style="max-height: calc(100vh - 419px); overflow-y: scroll;">
      <table
        mat-table
        aria-label="Elements"
        [dataSource]="mrsDataSource"
        matSort
        [matSortActive]="initialSort"
        matSortDirection="asc"
        style="width:100%; overflow:hidden;"
      >
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.def">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            disableClear
            [ngStyle]="column.columnStyles"
          >
            {{ column.header }}
          </th>

          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="!column.isAction; else actionCell">
              <ng-container *ngIf="column.def !== 'name'; else nameColumn">
                <div *ngFor="let rowDef of column.rowDefs">
                  <div [ngClass]="rowDef.className">{{ row[rowDef.dataName] }}</div>
                </div>
              </ng-container>
              <ng-template #nameColumn>
                <div class="d-flex align-items-center">
                  <div class="user-available-state" [ngClass]="{'available-user': row['isAvailable']}"></div>
                  <div>
                    <div *ngFor="let rowDef of column.rowDefs">
                      <div [ngClass]="rowDef.className">{{ row[rowDef.dataName] }}</div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>             
            <ng-template #actionCell>
              <ng-container *ngIf="column.isAction && canRead">
                <div class="w-100 text-end">
                  <div *ngFor="let action of column.actions">
                    <button
                      *ngIf="action.permission"
                      type="button"
                      mat-button
                      color="primary"
                      class="material-default"
                      (click)="tableAction(action, row); $event.stopPropagation()"
                    >
                      {{ action.name }}
                    </button>
                  </div>
                </div>
              </ng-container>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsDef; sticky: true"></tr>
        <tr
          mat-row
          (click)="onRowClicked(row)"
          *matRowDef="let row; columns: displayedColumnsDef;"
          class="row-height"
          [class.disabled-click]="!canRead"
          style="cursor: pointer"
        >
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="p-4 text-center text-muted">
              <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
              <h6>No Teams Found</h6>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div>
    <div class="flex mat-paginator-sticky mat-mdc-paginator-container">
      <mat-paginator
        #paginator
        [length]="mrsDataSource?.data?.length || 0"
        [pageIndex]="0"
        [pageSize]="10"
        appearance="fill"
        [pageSizeOptions]="[10, 25, 50, 100]"
      >
      </mat-paginator>
    </div>
  </div>
</div>
